import { throttle } from 'lodash-es';
import React, { useState, useEffect, useCallback} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    loadMore,
    setPaginationInfo,
    saveQuery,
} from '../Actions/LoadMore.action';
import { translate } from '../Services/translation';

const LoadMoreButton = ({ pageCount }) => {
    const { currentPageIndex, loaded } = useSelector((state) => state.loadMore);
    const [hasFirstLoad, setHasFirstLoad] = useState([0]);
    const [showButton, setShowButton] = useState(false);
    const [elementInViewNumber, setElementInViewNumber] = useState(0);
    const [y, setY] = useState(window.scrollY);

    const dispatch = useDispatch();

    const loadPage = (up) => {
        const blocks = document.querySelectorAll('.replace-state > .spann');
        const list = document.querySelector(
            '.replace-state'
        );
        let currBlockIndex = 0;

        if (blocks) {
            if (!up) {
                let endOfPage = false;
                const currentLastBlock = blocks[blocks.length - 1]; 

                if (currentLastBlock) {
                    const listProps = list.getBoundingClientRect();
                    const listBottom = listProps.bottom;
                    endOfPage = listBottom <= window.innerHeight * 1.25;
                    currBlockIndex = currentLastBlock.dataset.currentPageIndex;
                }

                if (
                    endOfPage &&
                    !hasFirstLoad.includes(parseInt(currBlockIndex) + 1)
                ) {
                    setHasFirstLoad([
                        ...hasFirstLoad,
                        parseInt(currBlockIndex) + 1,
                    ]);
                    nextPage(currBlockIndex, false);
                }
            } else {
               
                let topOfPage = false;
                const currentFirstBlock = blocks[0];
               

                if (currentFirstBlock) {
                    const currentFirstListItemProps = currentFirstBlock.getBoundingClientRect();
                    const elemTop = currentFirstListItemProps.top;
                    currBlockIndex = currentFirstBlock.dataset.currentPageIndex;
                    topOfPage = elemTop > 0;
                }

                if (
                    topOfPage &&
                    !hasFirstLoad.includes(parseInt(currBlockIndex) - 1)
                ) {
                    setHasFirstLoad([
                        ...hasFirstLoad,
                        parseInt(currBlockIndex) - 1,
                    ]);
                    nextPage(currBlockIndex, true);
                }
            }
        }
    };

    const updateUrl = () => {
        const lists = document.querySelectorAll('ul.product-list > .spann');
        for (const el of lists) {
            const inView = isScrolledIntoView(el);
            const dataCurrentPage = parseInt(el.dataset.currentPageIndex) || 1;

            if (inView && elementInViewNumber !== dataCurrentPage) {
                setElementInViewNumber(dataCurrentPage);
                let q = new URLSearchParams(window.location.search);
                q.set('page', dataCurrentPage);
                q = q.toString();
                dispatch(saveQuery(q));
                break;
            }
        }
    }
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const pageValue = queryParams.get('page');
        const pageNumber = parseInt(pageValue) || 1;
        dispatch(setPaginationInfo(pageNumber));
        if (!hasFirstLoad.includes(pageNumber)) {
            setHasFirstLoad([...hasFirstLoad, pageNumber]);
        }
        if (pageNumber === 1) {
            setShowButton(true);
        }
        const lsObj = localStorage.getItem('lazyInfo');
       
        if (lsObj && window.history.state == 'search') {
            const lastPageVisited = parseInt(JSON.parse(lsObj).page) || 1;
            if (lastPageVisited !== 1) {
                setShowButton(false);
            }
            const wrapper = document.querySelector(`#search-result`);
           
            if (pageNumber !== lastPageVisited) {
               
                const box = document.createElement('div');
                box.style.height = JSON.parse(lsObj).blockHeight + 'px';
                box.style.width = '100%';
                box.id = 'temp-space';
                wrapper.appendChild(box);
            }
            let initScroll = 0;
            initScroll = wrapper.offsetTop;
            const scrollVal =
                -1 * parseInt(JSON.parse(lsObj).scrollY) + parseInt(initScroll);
            window.scrollTo(0, scrollVal);
        }
        window.localStorage.removeItem('lazyInfo');

       
        return () => {
          
            const queryParams = new URLSearchParams(window.location.search);
            const pageNumber = queryParams.get('page') || 1;
            const blocks = document.querySelectorAll('.replace-state > .spann');
            const list = document.querySelector('.replace-state');
            const currentLastBlock = blocks[blocks.length - 1];
            const scroll = document
                .querySelector(`#list-${pageNumber}`)
                .getBoundingClientRect().top;

            const lsObj = {
                scrollY: scroll,
                page: currentLastBlock.dataset.currentPageIndex,
                blockHeight: list.getBoundingClientRect().bottom - currentLastBlock.getBoundingClientRect().top,
            };
           window.localStorage.setItem('lazyInfo', JSON.stringify(lsObj));
        };
    }, [dispatch, pageCount]);

    const handleScroll = useCallback(
        (e) => {
            const window = e.currentTarget;
            if (window) {
                if (y > window.scrollY) {
                    if (parseInt(pageCount) > 1) {
                        if (!hasFirstLoad.includes(1)) {
                            loadPage(true);
                        }
                    }
                } else if (y < window.scrollY) {
                    if (
                        parseInt(pageCount) > 1 &&
                        parseInt(pageCount) > Math.max(...hasFirstLoad)
                    ) {
                        if (
                            !showButton &&
                            Math.max(...hasFirstLoad) !== parseInt(pageCount)
                        ) {
                            loadPage(false);
                        }
                    }
                }
                if (parseInt(pageCount) > 1) {
                    updateUrl();
                }
                setY(window.scrollY);
            }
        },
        [y, currentPageIndex, showButton, hasFirstLoad]
    );

    useEffect(() => {
        setY(window.scrollY);
        const throttledScroll = throttle(handleScroll, 300);
        window.addEventListener('scroll', throttledScroll);
        return () => {
            window.removeEventListener('scroll', throttledScroll);
            
        };
    }, [handleScroll]);

    const isScrolledIntoView = (el) => {
        const rect = el.getBoundingClientRect();
        const id  = parseInt(el.dataset.currentPageIndex) + 1;
        let nextEl = document.querySelector(`#list-${id}`)
        let elemBottom;
        if(nextEl){
            elemBottom = nextEl.getBoundingClientRect().top
        }
        else{
            nextEl = document.querySelector('.replace-state');
            elemBottom = nextEl.getBoundingClientRect().bottom;
        }
        const elemTop = rect.top;        
        const isVisible =
            (elemTop >= 0 && elemBottom <= window.innerHeight) ||
            (elemTop <= 100 && elemBottom > 100);

        return isVisible;
    };


    const nextPage = (currentPage, prev) => {
        const nextPrevPage = prev
            ? parseInt(currentPage) - 1
            : parseInt(currentPage) + 1;
        dispatch(loadMore(nextPrevPage, prev));
    };
    return (
        <div
            className={`${
                'load-more-button center' +
                (!loaded ? ' load-more-button--loading' : '')
            }`}
        >
            {parseInt(currentPageIndex) !== parseInt(pageCount) &&
            showButton ? (
                <button
                    type="button"
                    className="load-more-button__button"
                    onClick={(event) => {
                        nextPage(currentPageIndex, false);
                        setShowButton(false);
                        setHasFirstLoad([...hasFirstLoad, 2]);
                    }}
                >
                    {translate('category.loadmore.showmore')}
                </button>
            ) : (
                !loaded && <span></span>
            )}
        </div>
    );
};

export default LoadMoreButton;
